import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork"; 
import { OptionModel } from "../../common/types/OptionModel";
export const getfirmCurrencyList = createAsyncThunk(
  "/getFirmCurrencyList/get",
  async (_, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/firm/firm-currencies");
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e:any) {
      return rejectWithValue(e.data.message);
    }
  }
);
 
export type CurrencyItemType={
  currencyId:number,
  currencyIsoCode:string,
  currencySymbol: string,
  currencyName:String,
  currencyDesc: string
}
export type CurrencyListSliceProps = {
  currencyList:  Array<CurrencyItemType>,
  currencyListForSelect:  Array<OptionModel>,
  isFetching: boolean,
  isSuccess: boolean,
  isError: boolean,
  errorMessage: string
}

export const firmCurrencyListSlice = createSlice({
  name: "firmCurrencyList",
  initialState: {
    currencyList: [],
    currencyListForSelect:[]as OptionModel[],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.currencyList = [];
      state.currencyListForSelect = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getfirmCurrencyList.fulfilled, (state, { payload }) => {
      state.currencyList = payload;

      const result :Array<OptionModel>= [];
      for (let i = 0; i < payload.length; i++) {
        const element = payload[i];
        result.push({
          label: element.currencyDesc,
          value: element.currencyId
        });
      }
      state.currencyListForSelect = result;

      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getfirmCurrencyList.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getfirmCurrencyList.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = firmCurrencyListSlice.actions;

export const firmCurrencyListSelector = (state:any) => state.firmCurrencyList;

export const firmCurrencyListReducer = firmCurrencyListSlice.reducer;
